document.addEventListener('DOMContentLoaded', () => {
  function initCarousel() {
    const colorsContainer = document.querySelector('.webyzeProductColors.webyzeProductColorsLarge');
    const wrapper = document.querySelector('.itzswatch');

    if (!colorsContainer || !wrapper) {
      // Retry after 300ms if elements are not yet in DOM
      setTimeout(initCarousel, 300);
      return;
    }

    // Your existing code to create arrows and event listeners here
    // ...

    const leftArrow = document.createElement('button');
    leftArrow.classList.add('carousel-arrow', 'left-arrow');
    leftArrow.setAttribute('aria-label', 'Scroll colors left');
    leftArrow.textContent = '<';

    const rightArrow = document.createElement('button');
    rightArrow.classList.add('carousel-arrow', 'right-arrow');
    rightArrow.setAttribute('aria-label', 'Scroll colors right');
    rightArrow.textContent = '>';

    wrapper.insertBefore(leftArrow, colorsContainer);
    wrapper.appendChild(rightArrow);

    const scrollAmount = 100;

    leftArrow.addEventListener('click', () => {
      colorsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      colorsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    function updateArrows() {
      leftArrow.style.display = colorsContainer.scrollLeft > 0 ? 'block' : 'none';
      rightArrow.style.display = (colorsContainer.scrollLeft + colorsContainer.clientWidth) < colorsContainer.scrollWidth ? 'block' : 'none';
    }

    colorsContainer.addEventListener('scroll', updateArrows);
    updateArrows();
  }

  initCarousel();
});
